// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__12Nkh","notes":"Notes_notes__3yCt5"};